import './style/index.scss'

import './controls/enter.js'
import './controls/play.js'
import './controls/start.js'
import './controls/poster.js'
import './controls/flex.js'
import './controls/fullscreen.js'
import './controls/cssFullscreen.js'
import './controls/volume.js'
import './controls/definition.js'
import './controls/loading.js'
import './controls/progress.js'
import './controls/time.js'
import './controls/replay.js'
import './controls/playbackRate.js'
import './controls/localPreview.js'
import './controls/download.js'
import './controls/danmu.js'
import './controls/pip.js'
import './controls/playNext.js'
import './controls/rotate.js'
import './controls/reload.js'
import './controls/screenShot.js'
import './controls/textTrack.js'
import './controls/error.js'
import './controls/memoryPlay.js'
